import { render, staticRenderFns } from "./JigsawConfig.vue?vue&type=template&id=e2cb8d2e"
import script from "./JigsawConfig.vue?vue&type=script&lang=js"
export * from "./JigsawConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports